import React, { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import { useLocation } from '../context/location/LocationContext'
import LocationMapVector from '../ui-elements/LocationMapVector'
import YellowAlert from '../ui-elements/YellowAlert'
import Spinner from '../ui-elements/Spinner'

type Props = {
  setQuestionAnswer: any
  defaultValue?: null | string | string[]
  questionId?: string
}

function QuestionLocation({ setQuestionAnswer }: Props) {
  const { t } = useContext(GlobalContext)
  const { locationFromGps, locationFromUser, locationAsString, locationError } = useLocation()
  const [locationManuallyEntered, setLocationManuallyEntered] = useState('')

  useEffect(() => {
    if (locationManuallyEntered) {
      setQuestionAnswer({ locationManuallyEntered })
    } else if (locationFromGps && locationFromUser) {
      setQuestionAnswer({ locationFromGps, locationFromUser, locationAsString })
    } else if (locationFromGps) {
      setQuestionAnswer({ locationFromGps, locationAsString })
    }
  }, [locationFromGps, locationFromUser, locationAsString, locationManuallyEntered])

  if (!locationFromGps && !locationError) {
    return <Spinner size='large'>{t('QuestionPages.QuestionLocation.gettingLocation')}</Spinner>
  }

  if (locationError) {
    return <div className="w-full flex flex-col gap-6">
      <YellowAlert icon={true} size='large' alignment='left'>
        <div className="w-full flex flex-col">
          <h2 className="text-lg font-bold">{t('QuestionPages.QuestionLocation.couldNotDetectHeading')}</h2>
          <p>{t('QuestionPages.QuestionLocation.locationError', { errorType: locationError })}</p>
        </div>
      </YellowAlert>
      <div className="w-full flex flex-col gap-4">
        <p className="text-3xl font-righteous text-brandblue">{t('QuestionPages.QuestionLocation.manuallyEnterLabel')}</p>
        <input
          type='text'
          className="text-center text-lg px-5 py-3 bg-white drop-shadow-lg border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full"
          value={locationManuallyEntered}
          onChange={(e) => setLocationManuallyEntered(e.target.value)}
        />
      </div>
    </div>
  }

  return <LocationMapVector
    locationManuallyEntered={locationManuallyEntered}
    setLocationManuallyEntered={setLocationManuallyEntered}
  />
}

export default QuestionLocation
